import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const EmailCapture = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // No backend hookup,  just visual feedback
    if (name && email) {
      setSubmitted(true);
      setName("");
      setEmail("");
      setTimeout(() => setSubmitted(false), 5000);
    }
  };

  return (
    <section className="py-24 bg-gradient-to-b from-void via-blood/5 to-void relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blood/10 via-transparent to-blood/10 animate-smoke" />
      
      <div className="container mx-auto px-4 relative z-10 max-w-3xl">
        <div className="border-2 border-blood bg-card/20 backdrop-blur-sm p-12">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-4 tracking-tight">
            <span className="text-blood-bright">Get the First Chapter Free</span>
          </h2>
          
          <p className="text-center text-steel text-lg mb-2">
            "The Mirror Ritual",  delivered to your inbox
          </p>
          
          <p className="text-center text-ash text-sm mb-8 italic">
            (Warning: Most people can't finish reading it. It's too brutal.)
          </p>

          {submitted ? (
            <div className="bg-blood/20 border border-blood-bright p-6 text-center animate-fade-in">
              <p className="text-blood-bright text-xl font-bold mb-2">
                Check your inbox.
              </p>
              <p className="text-steel text-sm">
                The Mirror Ritual is on its way. Don't be surprised if you can't look at yourself the same way again.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Input
                  type="text"
                  placeholder="Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                  className="bg-void border-smoke text-foreground placeholder:text-ash h-14 text-lg focus:border-blood-bright transition-colors"
                />
              </div>
              
              <div>
                <Input
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="bg-void border-smoke text-foreground placeholder:text-ash h-14 text-lg focus:border-blood-bright transition-colors"
                />
              </div>

              <Button 
                type="submit"
                size="lg"
                className="w-full bg-blood-bright hover:bg-blood text-primary-foreground py-6 text-xl font-bold uppercase tracking-widest transition-all hover:shadow-[0_0_40px_rgba(220,38,38,0.6)]"
              >
                Send Me The First Chapter
              </Button>

              <p className="text-xs text-ash text-center italic mt-4">
                No spam. No bullshit. Just brutal truth delivered once. Unsubscribe anytime.
              </p>
            </form>
          )}
        </div>

        <p className="text-center text-steel text-sm mt-8 italic">
          Join 12,847 others who couldn't handle the mirror.
        </p>
      </div>
    </section>
  );
};
